import * as api from '@/api/fdback'
import cookie from 'js-cookie'
import { fdback } from '@/store/mutation-type'

const state = {
    info: {},
    helpfdbackList: []
}

const getters = {
    [fdback.FDBA_LIST]: (state) => {
        return state.helpfdbackList[state.info['APP']]
    }
}

const actions = {
    [fdback.CLIENT_INFO]: ({ commit }) => {
        commit(fdback.CLIENT_INFO, cookie.get())
    },
    [fdback.FDBACK_LIST]: ({ commit }) => {
        // console.log(0)
        api.helpFdbackData({}, (_data) => commit(fdback.FDBACK_LISTS, _data))
    }
}

const mutations = {
    [fdback.FDBACK_LISTS]: function (state, _data) {
        state.helpfdbackList = _data
        // console.log(_data)
    },
    [fdback.CLIENT_INFO]: function (state, _data) {
        state.info = _data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fdback.js